import { Cookies } from "react-cookie";
const cookies = new Cookies();

export const KEY_TOKEN = "token";
export const KEY_ADDRESS = "address";
export const KEY_CI = "ci";
export const KEY_CART = "cart";
export const KEY_PUBLISH = "publish";
export const KEY_OVER_ADULT = "overAdult";
export const KEY_OVER_FOURTEEN = "overFourteen";
export const KEY_PAYMENT = "payment";
export const KEY_COVERAGE = "coverage";
export const KEY_USERLOGIN = "coverage";
const Storage = {
  // TOKEN
  setToken(token) {
    cookies.remove(KEY_TOKEN);
    cookies.set(KEY_TOKEN, token, {
      maxAge: 7776000,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },

  getToken() {
    return cookies.get(KEY_TOKEN);
  },

  removeToken() {
    cookies.remove(KEY_TOKEN);
  },

  // ADDRESS
  setAddress(address) {
    cookies.remove(KEY_ADDRESS);
    cookies.set(KEY_ADDRESS, address, {
      maxAge: 60 * 60 * 5,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },

  setCi(ci) {
    cookies.remove(KEY_CI);
    cookies.set(KEY_CI, ci, {
      maxAge: 60 * 60 * 5,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },

  getCi() {
    return cookies.get(KEY_CI) ? cookies.get(KEY_CI) : {};
  },

  getAddress() {
    return cookies.get(KEY_ADDRESS) ? cookies.get(KEY_ADDRESS) : {};
  },

  removeAddress() {
    cookies.remove(KEY_ADDRESS);
  },

  // CART
  setCart(cart) {
    cookies.remove(KEY_CART);
    cookies.set(KEY_CART, cart, {
      maxAge: 60 * 60 * 5,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },

  getCart() {
    return (cookies.get(KEY_CART) && cookies.get(KEY_CART)) || [];
  },

  removeCart() {
    cookies.remove(KEY_CART);
  },

  // PUBLICIDAD
  setPublish(publish) {
    cookies.remove(KEY_PUBLISH);
    cookies.set(KEY_PUBLISH, publish, {
      maxAge: 60 * 60 * 5,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },

  getPublish() {
    return cookies.get(KEY_PUBLISH);
  },

  // PUBLICIDAD
  setPaymentCard(payment) {
    cookies.remove(KEY_PAYMENT);
    cookies.set(KEY_PAYMENT, payment, {
      maxAge: 60 * 60 * 5,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },

  getPaymentCard() {
    return cookies.get(KEY_PAYMENT);
  },

  removePaymentCard() {
    cookies.remove(KEY_PAYMENT);
  },

  // OVER ADULT
  setOverAdult(option) {
    cookies.remove(KEY_OVER_ADULT);
    cookies.set(KEY_OVER_ADULT, option, {
      maxAge: 60 * 60 * 5,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },
  getOverAdult() {
    return cookies.get(KEY_OVER_ADULT);
  },

  removeOverAdult() {
    cookies.remove(KEY_OVER_ADULT);
  },

  //COVERAGE
  setCoverage(option) {
    cookies.set(KEY_COVERAGE, option, {
      path: "/",
      secure: true,
    });
  },
  getCoverage() {
    return cookies.get(KEY_COVERAGE);
  },

  removeCoverage() {
    cookies.remove(KEY_COVERAGE, { path: "/" });
  },

  // OVER FOURTEEN
  setOverFourteen(option) {
    cookies.remove(KEY_OVER_FOURTEEN);
    cookies.set(KEY_OVER_FOURTEEN, option, {
      maxAge: 60 * 60 * 5,
      sameSite: "lax",
      path: "/",
      secure: true,
    });
  },

  getOverFourteen() {
    return cookies.get(KEY_OVER_FOURTEEN);
  },

  removeOverFourteen() {
    cookies.remove(KEY_OVER_FOURTEEN);
  },

  //USER LOG IN
  setUserLogIn(option) {
    cookies.set(KEY_USERLOGIN, option, {
      path: "/",
      secure: true,
    });
  },
  getUserLogIn() {
    return cookies.get(KEY_USERLOGIN);
  },

  removeUserLogIn() {
    cookies.remove(KEY_USERLOGIN, { path: "/" });
  },
};

export default Storage;
